

























import { Component, Prop, Vue } from 'vue-property-decorator'
import { useDeleteScripts, useGetAITemplates } from '@/hooks/openAi'
import moment from 'moment'
import get from 'lodash.get'

@Component({
  setup() {
    const { mutate: deleteScript, isLoading: isDeleting } = useDeleteScripts()
    const { data: aiTemplateList } = useGetAITemplates()

    return {
      deleteScript,
      isDeleting,
      aiTemplateList,
    }
  },
})
export default class AICScriptCard extends Vue {
  @Prop() script!: any

  deleteScript!: any
  isDeleting!: boolean
  aiTemplateList!: any

  get formatDate() {
    const momentObj = moment(this.script.createdOn)
    return momentObj.format('D MMM, YYYY @HH:mm')
  }

  get templateList() {
    return get(this, 'aiTemplateList', []).reduce((acc: any, obj: any) => {
      acc[obj.enum] = obj
      return acc
    }, {})
  }

  editScript() {
    this.$router.push(`/ai/template/${this.script.id}?enum=${this.templateList[this.script.template].enum}`)
  }
}
